import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './PageProfile.css';
import MasterOperationRenderer from '../../Pages/OverlayPage/OverlayPage';

const PageProfileModal = ({ userId, operationType, profileId, onClose }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(0); // Go back to background page (e.g., home)
  };

  return (
    <div className="pp-modal-overlay">
      <div className="pp-modal-content" style={{ color: 'none', width: 1200, height: 1000}}> 
      <button className="pp-modal-close" onClick={handleClose} style={{background: "none", width: 40, justifyContent: "right"}}>✕</button>
      <MasterOperationRenderer
          operationType={operationType}
          data={{userId}}
          profileId={profileId}
        />
      </div>
    </div>
  );
};

export default PageProfileModal;
